import AppRecord from './AppRecord.js'

class AverageAcquisitionCost extends AppRecord {
  // Composite key - the backend table has no single id column
  get primary_key(){
    return this.entity_id+','+this.issue_id+','+this.date
  }
}

export default AverageAcquisitionCost
